const DEFAULT_LOCALE =
    (typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage)) || 'en-US';

const relativeTimeFormatterCache = new Map();

const getRelativeFormatter = (locale) => {
    const cacheKey = locale || DEFAULT_LOCALE;
    if (!relativeTimeFormatterCache.has(cacheKey)) {
        relativeTimeFormatterCache.set(
            cacheKey,
            new Intl.RelativeTimeFormat(cacheKey, { numeric: 'auto' }),
        );
    }
    return relativeTimeFormatterCache.get(cacheKey);
};

const RELATIVE_DIVISIONS = [
    { amount: 60, unit: 'second' },
    { amount: 60, unit: 'minute' },
    { amount: 24, unit: 'hour' },
    { amount: 7, unit: 'day' },
    { amount: 4.34524, unit: 'week' },
    { amount: 12, unit: 'month' },
    { amount: Number.POSITIVE_INFINITY, unit: 'year' },
];

export const formatLastSeenRelative = (lastSeen, { locale } = {}) => {
    if (!lastSeen) {
        return null;
    }

    const parsed = Date.parse(lastSeen);
    if (Number.isNaN(parsed)) {
        return null;
    }

    const formatter = getRelativeFormatter(locale);
    let duration = (parsed - Date.now()) / 1000;

    if (duration > 0) {
        return formatter.format(0, 'second');
    }

    for (const division of RELATIVE_DIVISIONS) {
        if (Math.abs(duration) < division.amount) {
            return formatter.format(Math.round(duration), division.unit);
        }
        duration /= division.amount;
    }

    return formatter.format(Math.round(duration), 'year');
};
